import {
  Box, Typography, Button, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Chip, IconButton, Tooltip,
  CircularProgress,
} from "@mui/material";
import { Add, Edit, Delete, OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useGetCmsPostsQuery, useDeleteCmsPostMutation } from "../../../app/websiteApiSlice";
import toast from "../../../helpers/toast";

export default function CmsPostsManage() {
  const { data: posts = [], isLoading } = useGetCmsPostsQuery();
  const [deletePost, { isLoading: deleting }] = useDeleteCmsPostMutation();

  async function handleDelete(post) {
    if (!window.confirm(`Delete "${post.title}"?`)) return;
    try {
      await deletePost(post.id).unwrap();
      toast.success("Post deleted");
    } catch (err) {
      toast.error(err?.message || "Failed to delete");
    }
  }

  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={3}>
        <Typography variant="h5" fontWeight={700}>Posts</Typography>
        <Button variant="contained" startIcon={<Add />} component={Link} to="/cms/posts/new">
          New Post
        </Button>
      </Box>

      {isLoading ? (
        <Box display="flex" justifyContent="center" p={4}><CircularProgress /></Box>
      ) : (
        <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2 }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ "& th": { fontWeight: 600 } }}>
                <TableCell>Title</TableCell>
                <TableCell>Slug</TableCell>
                <TableCell>Categories</TableCell>
                <TableCell>Status</TableCell>
                <TableCell align="right">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {posts.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography variant="body2" color="text.secondary" align="center" py={3}>
                      No posts yet. Create your first post!
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {posts.map((post) => (
                <TableRow key={post.id} hover>
                  <TableCell>{post.title}</TableCell>
                  <TableCell>
                    <Typography variant="caption" color="text.secondary">
                      /blog/{post.slug}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Box display="flex" flexWrap="wrap" gap={0.5}>
                      {post.categories?.map((c) => (
                        <Chip key={c.id} label={c.name} size="small" variant="outlined" />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={post.status}
                      size="small"
                      color={post.status === "published" ? "success" : "default"}
                    />
                  </TableCell>
                  <TableCell align="right">
                    {post.status === "published" && (
                      <Tooltip title="View post">
                        <IconButton size="small" component="a" href={`/blog/${post.slug}`} target="_blank">
                          <OpenInNew fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                    <Tooltip title="Edit">
                      <IconButton size="small" component={Link} to={`/cms/posts/${post.id}/edit`}>
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton size="small" color="error" onClick={() => handleDelete(post)} disabled={deleting}>
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
